import React from 'react';
import { withRouter } from 'react-router-dom'
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Swal from 'sweetalert2'
import axios from 'axios';
import { API_MOSA_URL, ACCESS_TOKEN_NAME } from '../constants/apiContants';
import LoadingOverlay from 'react-loading-overlay';
import "./Dash.css";

import "./Profile.css";

const devicedetails = {
    "imei": "862188038288320",
    "deviceOSVersion": "6.0.1",
    "uuid": "862188038288320",
    "deviceModel": "NOKIA 100",
    "deviceManufacturer": "Xiaomi",
    "serviceProvider": "airtel",
    "deviceOS": "ANDROID",
    "ipAddress": "192.168.43.210"
}
const headers = {
    "RequestMode": "0",
    "UserID": localStorage.getItem('userid'),
    "BearerKey": "Mobile",
    "ServiceId": "SERV!",
    "SessionId": localStorage.getItem(ACCESS_TOKEN_NAME),
    "Locale": "E/A",
    "DeviceDet": devicedetails

}

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0,
            locations: [],
            stadiums: [],
            location: '',
            stadium: '',
            isActive: false,
            email: localStorage.getItem('userEmail'),
            mobile: localStorage.getItem('userPhone'),
            facilities: []
        };
        this.setState = this.setState.bind(this);
        this.setTabIndexDetails = this.setTabIndexDetails.bind(this);
        this.searchFacilities = this.searchFacilities.bind(this);

    }
    showLoader() {

    }
    setTabIndexDetails = (event, index) => {
        console.log(index);
        this.setState({ tabIndex: index });
    }
    myChangeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }
    // handelOnUploadFile = (event) => {
    //   console.log("File ::: " + JSON.stringify(event.target.files[0]));
    //   this.setState({
    //     document: event.target.files[0]
    //   })
    // }
    getFiles(file) {
        this.setState({ document: file })
    }
    getFilesDoc(file) {
        this.setState({ documentId: file })
    }
    venue = (event) => {
        let self = this; //  declared var welcom

        this.setState({ isActive: true });

        //this.setState({location: event.target.value});
        const mosa = { ReqHead: headers, "stadium_id": this.state.stadium }


        axios.post(API_MOSA_URL + '/User/GetFacilityListByStadium', mosa)

            .then(function (response) {
                console.log(JSON.stringify(response.data));
                // self.redirectToValidate();
                self.setState({ isActive: false });

                if (response.status === 200) {

                    if (response.data[0].StatusCode == "0") {

                        self.setState({ facilities: response.data[1] });

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });
    }
    componentDidMount() {

        let self = this; //  declared var welcom

        this.setState({ isActive: true });
        const mosa = { ReqHead: headers }


        axios.post(API_MOSA_URL + '/User/GetLocationList', mosa)

            .then(function (response) {
                console.log(JSON.stringify(response.data.data));
                // self.redirectToValidate();
                self.setState({ isActive: false });

                if (response.status === 200) {

                    if (response.data[0].StatusCode == "0") {

                        self.setState({ locations: response.data[1] });

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });

    }
    change = (event) => {

        // alert( event.target.value);
        this.setState({ isActive: true });

        this.setState({ location: event.target.value });
        const mosa = { ReqHead: headers, "location_id": event.target.value }
        let self = this;

        axios.post(API_MOSA_URL + '/User/GetStadiumListByLocation', mosa)

            .then(function (response) {
                console.log(JSON.stringify(response.data));
                // self.redirectToValidate();
                self.setState({ isActive: false });

                if (response.status === 200) {

                    if (response.data[0].StatusCode == "0") {

                        self.setState({ stadiums: response.data[1] });

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });
    }
    stadiumChange = (event) => {
        //alert(event.target.value);
        //this.setState({ isActive: true });

        this.setState({ stadium: event.target.value });
    }
    searchFacilities = (event) => {


    }
    render() {
        let self = this;

        let locations = this.state.locations;
        let optionItems = locations.map((location) =>
            <option value={location.location_mast_id}>{location.location_name_en}</option>
        );

        let stadiums = this.state.stadiums;
        let stadItems = stadiums.map((stadium) =>
            <option value={stadium.stadium_mast_id}>{stadium.stadium_name_en}</option>
        );

        let commentNodes = this.state.facilities.map(function (facility, index) {
            return <div key={index}>
                <br />
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-3" style={{ marginTop: '25px' }}>
                                <img src="https://media-cdn.tripadvisor.com/media/photo-s/01/1d/05/ff/nice-swimming-pool.jpg" />
                            </div>
                            <div className="col-md-6  card-body">
                                <div className="list-title">
                                    <ul className="list-inline list-unstyled">
                                        <li className="list-inline-item"><a href="#"><h4>{facility.facility_name_en}</h4></a></li>
                                        <li className="list-inline-item text-warning"><i className="fa fa-star" /><i className="fa fa-star" /><i className="fa fa-star" /><i className="fa fa-star" /><i className="fa fa-star-half" /></li>
                                        <li className="list-inline-item text-success"><i className="fa fa-thumbs-up" /></li>
                                    </ul>
                                </div>
                                <div className="list-location">
                                    <a href="#"><i className="fa fa-map-marker" /><small> Location description will be coming here</small> </a>
                                </div>
                                <div className="list-descrip">
                                    <small>
                                        Facility description will be coming here                                                              </small>
                                </div>
                            </div>
                            <div className="col-md-3 border-left card-body">
                                <ul className="list-unstyled">
                                    <li><h3>OMR {facility.rate}</h3></li>
                                    {/* <li className="text-secondary"><small>22 Reviews</small></li> */}
                                </ul>
                                <button type="button" className="btn btn-outline-primary" >Explore Facility</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>;
        });
        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner
                text='Loading ...'
            >
                <div style={{ backgroundColor: 'grey' }}>
                    <Navbar />


                    <div className="container">
                        <div className="subheader py-5 py-lg-10 gutter-b subheader-transparent" id="kt_subheader" style={{ backgroundColor: '#663259', backgroundPosition: 'right bottom', backgroundSize: 'auto 100%', backgroundRepeat: 'no-repeat', backgroundImage: 'url(/metronic/theme/html/demo4/dist/assets/media/svg/patterns/taieri.svg)' }}>
                            <div className="container d-flex flex-column">
                                {/*begin::Title*/}
                                <div className="d-flex align-items-sm-end flex-column flex-sm-row mb-5">
                                    <h2 className="d-flex align-items-center text-white mr-5 mb-0">Search Job</h2>
                                    <span className="text-white opacity-60 font-weight-bold">Job Management System</span>
                                </div>
                                {/*end::Title*/}
                                {/*begin::Search Bar*/}
                                <div className="d-flex align-items-md-center mb-2 flex-column flex-md-row">
                                    <div className="bg-white rounded p-4 d-flex flex-grow-1 flex-sm-grow-0">
                                        {/*begin::Form*/}
                                        <form className="form d-flex align-items-md-center flex-sm-row flex-column flex-grow-1 flex-sm-grow-0">
                                            {/*begin::Input*/}
                                            <div className="d-flex align-items-center py-3 py-sm-0 px-sm-3">
                                                <span className="svg-icon svg-icon-lg">
                                                    {/*begin::Svg Icon | path:/metronic/theme/html/demo4/dist/assets/media/svg/icons/General/Search.svg*/}
                                                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                                                            <rect x={0} y={0} width={24} height={24} />
                                                            <path d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z" fill="#000000" fillRule="nonzero" opacity="0.3" />
                                                            <path d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z" fill="#000000" fillRule="nonzero" />
                                                        </g>
                                                    </svg>
                                                    {/*end::Svg Icon*/}
                                                </span>
                                                <input type="text" className="form-control border-0 font-weight-bold pl-2" placeholder="Job Title" />
                                            </div>
                                            {/*end::Input*/}
                                            {/*begin::Input*/}
                                            <span className="bullet bullet-ver h-25px d-none d-sm-flex mr-2" />
                                            <div className="d-flex align-items-center py-3 py-sm-0 px-sm-3">
                                                <span className="svg-icon svg-icon-lg">
                                                    {/*begin::Svg Icon | path:/metronic/theme/html/demo4/dist/assets/media/svg/icons/Layout/Layout-4-blocks.svg*/}
                                                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                                                            <rect x={0} y={0} width={24} height={24} />
                                                            <rect fill="#000000" x={4} y={4} width={7} height={7} rx="1.5" />
                                                            <path d="M5.5,13 L9.5,13 C10.3284271,13 11,13.6715729 11,14.5 L11,18.5 C11,19.3284271 10.3284271,20 9.5,20 L5.5,20 C4.67157288,20 4,19.3284271 4,18.5 L4,14.5 C4,13.6715729 4.67157288,13 5.5,13 Z M14.5,4 L18.5,4 C19.3284271,4 20,4.67157288 20,5.5 L20,9.5 C20,10.3284271 19.3284271,11 18.5,11 L14.5,11 C13.6715729,11 13,10.3284271 13,9.5 L13,5.5 C13,4.67157288 13.6715729,4 14.5,4 Z M14.5,13 L18.5,13 C19.3284271,13 20,13.6715729 20,14.5 L20,18.5 C20,19.3284271 19.3284271,20 18.5,20 L14.5,20 C13.6715729,20 13,19.3284271 13,18.5 L13,14.5 C13,13.6715729 13.6715729,13 14.5,13 Z" fill="#000000" opacity="0.3" />
                                                        </g>
                                                    </svg>
                                                    {/*end::Svg Icon*/}
                                                </span>
                                                <input type="text" className="form-control border-0 font-weight-bold pl-2" placeholder="Category" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-target="kt_searchbar_7_category-options" data-offset="0,10" readOnly="readonly" />
                                                <div id="kt_searchbar_7_category-options" className="dropdown-menu dropdown-menu-sm">
                                                    <div className="dropdown-item cursor-pointer">HR Management</div>
                                                    <div className="dropdown-item cursor-pointer">Developers</div>
                                                    <div className="dropdown-item cursor-pointer">Creative</div>
                                                    <div className="dropdown-divider" />
                                                    <div className="dropdown-item cursor-pointer">Top Management</div>
                                                </div>
                                            </div>
                                            {/*end::Input*/}
                                            {/*begin::Input*/}
                                            <span className="bullet bullet-ver h-25px d-none d-sm-flex mr-2" />
                                            <div className="d-flex align-items-center py-3 py-sm-0 px-sm-3">
                                                <span className="svg-icon svg-icon-lg">
                                                    {/*begin::Svg Icon | path:/metronic/theme/html/demo4/dist/assets/media/svg/icons/Media/Rec.svg*/}
                                                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                                                            <rect x={0} y={0} width={24} height={24} />
                                                            <path d="M12,16 C14.209139,16 16,14.209139 16,12 C16,9.790861 14.209139,8 12,8 C9.790861,8 8,9.790861 8,12 C8,14.209139 9.790861,16 12,16 Z M12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 C16.418278,4 20,7.581722 20,12 C20,16.418278 16.418278,20 12,20 Z" fill="#000000" fillRule="nonzero" />
                                                        </g>
                                                    </svg>
                                                    {/*end::Svg Icon*/}
                                                </span>
                                                <input id="kt_subheader_7_location" type="text" className="form-control border-0 font-weight-bold pl-2" placeholder="Location" data-toggle="modal" aria-haspopup="true" aria-expanded="false" data-target="#subheader7Modal" readOnly="readonly" />
                                            </div>
                                            {/*end::Input*/}
                                            <button type="submit" className="btn btn-dark font-weight-bold btn-hover-light-primary mt-3 mt-sm-0 px-7">Search</button>
                                        </form>
                                        {/*end::Form*/}
                                    </div>
                                    
                                </div>
                                {/*end::Search Bar*/}
                            </div>
                        </div>
                        <br />
                        <section className="search-sec">
                            <div className="container">
                                <form action="#" method="post" noValidate="novalidate">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-4 col-sm-12 p-0">
                                                    <select className="form-control" onChange={this.change} value={this.state.location}>
                                                        <option>Select Location</option>
                                                        {optionItems}
                                                    </select>
                                                </div>

                                                <div className="col-lg-4 col-md-4 col-sm-12 p-0">
                                                    <select className="form-control" id="exampleFormControlSelect1" onChange={this.stadiumChange} value={this.state.stadium}>
                                                        <option>Select Stadium</option>
                                                        {stadItems}
                                                    </select>
                                                </div>

                                                <div className="col-lg-4 col-md-4 col-sm-12 p-0">
                                                    <button type="button" className="btn btn-primary" style={{ width: '75%' }} onClick={this.venue} >Search</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </section>
                        <div>
                            <div cassName="">

                                <div className=" ">
                                    <div className="">
                                        <div className="row">
                                            <div className="col-sm-3 tab-contents-left" style={{ margin: '0px !important' }}>

                                                <br />

                                                <div className="card">
                                                    {/* filter-group  .// */}
                                                    <article className="filter-group">
                                                        <header className="card-header">
                                                            <a href="#" data-toggle="collapse" data-target="#collapse_2" aria-expanded="true" className>
                                                                <i className="icon-control fa fa-chevron-down" />
                                                                <h6 className="title">Facilities </h6>
                                                            </a>
                                                        </header>
                                                        <div className="filter-content collapse show" id="collapse_2" style={{}}>
                                                            <div className="card-body">
                                                                <label className="custom-control custom-checkbox">
                                                                    <input type="checkbox" defaultChecked className="custom-control-input" />
                                                                    <div className="custom-control-label">Locker Room
                  <b className="badge badge-pill badge-light float-right"></b></div>
                                                                </label>
                                                                <label className="custom-control custom-checkbox">
                                                                    <input type="checkbox" defaultChecked className="custom-control-input" />
                                                                    <div className="custom-control-label">Kids Pool
                  <b className="badge badge-pill badge-light float-right"></b></div>
                                                                </label>
                                                                <label className="custom-control custom-checkbox">
                                                                    <input type="checkbox" defaultChecked className="custom-control-input" />
                                                                    <div className="custom-control-label">Family Pool
                  <b className="badge badge-pill badge-light float-right"></b> </div>
                                                                </label>
                                                                <label className="custom-control custom-checkbox">
                                                                    <input type="checkbox" defaultChecked className="custom-control-input" />
                                                                    <div className="custom-control-label">Amenities
                  <b className="badge badge-pill badge-light float-right"></b> </div>
                                                                </label>
                                                                <label className="custom-control custom-checkbox">
                                                                    <input type="checkbox" className="custom-control-input" />
                                                                    <div className="custom-control-label">Parking
                  <b className="badge badge-pill badge-light float-right"></b></div>
                                                                </label>
                                                            </div> {/* card-body.// */}
                                                        </div>
                                                    </article> {/* filter-group .// */}
                                                    <hr />
                                                    <article className="filter-group">
                                                        <header className="card-header">
                                                            <a href="#" data-toggle="collapse" data-target="#collapse_3" aria-expanded="true" className>
                                                                <i className="icon-control fa fa-chevron-down" />
                                                                <h6 className="title">Price range </h6>
                                                            </a>
                                                        </header>
                                                        <div className="filter-content collapse show" id="collapse_3" style={{}}>
                                                            <div className="card-body">
                                                                <div className="form-row">
                                                                    <div className="form-group col-md-6">
                                                                        <label>Min</label>
                                                                        <input className="form-control" placeholder="0" type="number" />
                                                                    </div>
                                                                    <div className="form-group text-right col-md-6">
                                                                        <label>Max</label>
                                                                        <input className="form-control" placeholder="1,0000" type="number" />
                                                                    </div>
                                                                </div> {/* form-row.// */}
                                                                <button className="btn btn-block btn-primary">Apply</button>
                                                            </div>{/* card-body.// */}
                                                        </div>
                                                    </article> {/* filter-group .// */}




                                                </div>


                                                <br />

                                            </div>
                                            <div className="col-sm-9  tab-contents-out">
                                                <br />

                                                <div className="">
                                                    <ul>{commentNodes}</ul>

                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            {this.state.facilities.length > 0 &&
                                                                <ul className="pagination">
                                                                    <li className="page-item disabled"><a className="page-link" href="#">Previous</a></li>
                                                                    {this.state.facilities.map((page, index) => {



                                                                        return (
                                                                            <li key={index} className="page-item">
                                                                                <a className="page-link" href="#">{index + 1}</a>
                                                                            </li>

                                                                        );


                                                                    })}

                                                                    <li className="page-item"><a className="page-link" href="#">Next</a></li>
                                                                </ul>
                                                            }
                                                            {this.state.facilities.length == 0 &&
                                                                <div className="alert-message alert-message-warning">
                                                                    <h4>
                                                                        No Facilities selected</h4>
                                                                    <p>
                                                                        Please select Location and Stadium to search available facilities</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                            </div>
                        </div>


                    </div>


                    <Footer />
                </div>
            </LoadingOverlay >
        )
    }
}
export default withRouter(Dashboard);
